import "./App.css";
import SignUp from "./components/SignUp";

function App() {
  return (
    <div className="signup-container">
      <SignUp />
    </div>
  );
}

export default App;
